import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateAdminRole } from 'api/admin.service';
import { clearPermissionStore } from 'store/permission';
import { AxiosError } from 'axios';
import { UserRole } from 'models/user.model';
import { useToast } from 'hooks/ui';

export const useUpdateAdminQuery = () => {
  const toast = useToast();
  const queryClient = useQueryClient();

  const { isPending, mutate } = useMutation({
    mutationFn: ({ id, role }: { id: string; role: UserRole }) =>
      updateAdminRole(id, role),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admins'] });
      clearPermissionStore();
      toast.success('Admin role has been updated successfully');
    },
    onError: (error: AxiosError) => {
      toast.error(error.message);
    },
  });

  return { isLoading: isPending, mutate };
};
